import style from './Box.module.scss'
import { Routes, Route } from "react-router-dom";
import Trends from './trends/Trends';
import BoxContent from './boxContent/BoxContent';
import Movie from './movie/Movie';
import Bookmarks from './bookmarks/Bookmarks';

let Box = () => {
    return (<div className={style.Box}>
        <Routes>
            <Route path='*' element={<BoxContent />} />
            <Route path='/movieDetails/:filmId' element={<Movie />} />
            <Route path='/trends' element={<Trends />} />
            <Route path='/bookmarks' element={<Bookmarks />} />
        </Routes>
    </div >
    )
}

export default Box